import { FooterCopyright } from './footer-copyright';
import { FooterLinks } from './footer-links';
import { StyledFooter } from './styled';

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => (
  <StyledFooter>
    <FooterLinks />
    <FooterCopyright />
  </StyledFooter>
);
